/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MaskStatistics,
    MaskStatisticsFromJSON,
    MaskStatisticsFromJSONTyped,
    MaskStatisticsToJSON,
} from './';

/**
 * 
 * @export
 * @interface Pix2PixResult
 */
export interface Pix2PixResult {
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    contoursId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    ellipsesId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    exoMaskComparisonId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    histogramValidationId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    imageContoursExoId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    isletMaskComparisonEllipsesId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    isletMaskComparisonId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    maskCombinedId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    maskExoId: string;
    /**
     * 
     * @type {string}
     * @memberof Pix2PixResult
     */
    maskIsletsId: string;
    /**
     * 
     * @type {MaskStatistics}
     * @memberof Pix2PixResult
     */
    maskStatistics: MaskStatistics;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativeIsletArea: number;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativeIsletCount: number;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativeIsletVolumeEllipse: number;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativeIsletVolumeSphere: number;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativeIsletVolumeSpinacle: number;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativeIsletVolumeTable: number;
    /**
     * 
     * @type {number}
     * @memberof Pix2PixResult
     */
    relativePurity: number;
    /**
     * 
     * @type {MaskStatistics}
     * @memberof Pix2PixResult
     */
    userMaskStatistics: MaskStatistics;
}

export function Pix2PixResultFromJSON(json: any): Pix2PixResult {
    return Pix2PixResultFromJSONTyped(json, false);
}

export function Pix2PixResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pix2PixResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contoursId': json['contours_id'],
        'ellipsesId': json['ellipses_id'],
        'exoMaskComparisonId': json['exo_mask_comparison_id'],
        'histogramValidationId': json['histogram_validation_id'],
        'imageContoursExoId': json['image_contours_exo_id'],
        'isletMaskComparisonEllipsesId': json['islet_mask_comparison_ellipses_id'],
        'isletMaskComparisonId': json['islet_mask_comparison_id'],
        'maskCombinedId': json['mask_combined_id'],
        'maskExoId': json['mask_exo_id'],
        'maskIsletsId': json['mask_islets_id'],
        'maskStatistics': MaskStatisticsFromJSON(json['mask_statistics']),
        'relativeIsletArea': json['relative_islet_area'],
        'relativeIsletCount': json['relative_islet_count'],
        'relativeIsletVolumeEllipse': json['relative_islet_volume_ellipse'],
        'relativeIsletVolumeSphere': json['relative_islet_volume_sphere'],
        'relativeIsletVolumeSpinacle': json['relative_islet_volume_spinacle'],
        'relativeIsletVolumeTable': json['relative_islet_volume_table'],
        'relativePurity': json['relative_purity'],
        'userMaskStatistics': MaskStatisticsFromJSON(json['user_mask_statistics']),
    };
}

export function Pix2PixResultToJSON(value?: Pix2PixResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contours_id': value.contoursId,
        'ellipses_id': value.ellipsesId,
        'exo_mask_comparison_id': value.exoMaskComparisonId,
        'histogram_validation_id': value.histogramValidationId,
        'image_contours_exo_id': value.imageContoursExoId,
        'islet_mask_comparison_ellipses_id': value.isletMaskComparisonEllipsesId,
        'islet_mask_comparison_id': value.isletMaskComparisonId,
        'mask_combined_id': value.maskCombinedId,
        'mask_exo_id': value.maskExoId,
        'mask_islets_id': value.maskIsletsId,
        'mask_statistics': MaskStatisticsToJSON(value.maskStatistics),
        'relative_islet_area': value.relativeIsletArea,
        'relative_islet_count': value.relativeIsletCount,
        'relative_islet_volume_ellipse': value.relativeIsletVolumeEllipse,
        'relative_islet_volume_sphere': value.relativeIsletVolumeSphere,
        'relative_islet_volume_spinacle': value.relativeIsletVolumeSpinacle,
        'relative_islet_volume_table': value.relativeIsletVolumeTable,
        'relative_purity': value.relativePurity,
        'user_mask_statistics': MaskStatisticsToJSON(value.userMaskStatistics),
    };
}


